import { DependencyList, useEffect } from 'react';

export const useKeypress = (
  key: string | number,
  action: () => void,
  deps: DependencyList = []
) => {
  useEffect(() => {
    const onKeyup = (e: KeyboardEvent) => {
      if (e.key === key) action();
    };
    window.addEventListener('keyup', onKeyup);
    return () => window.removeEventListener('keyup', onKeyup);
  }, deps);
};
